import {
  getCurrentAccount,
  useCurrentAccount,
} from '@/store/use-account-store';
import { COLLATERAL_DECIMALS } from '@/store/use-markets-store';
import { bigIntToNum, formatNumber } from '@/utils/value-format';
import { ColumnDef } from '@tanstack/react-table';

type Props = {
  symbol: string;
};

export default function Funding({ symbol }: Props) {
  const funding = useCurrentAccount((state) => state.positions[symbol].funding);
  return (
    <span className={funding.bigint < 0n ? 'text-red' : 'text-green'}>
      {formatNumber(funding.decimal, {
        showChange: true,
        digits: 2,
      })}
    </span>
  );
}

export const fundingAccessorFn = (symbol: string) => {
  const { funding } = getCurrentAccount((state) => state.positions[symbol]);

  const fundingNum = bigIntToNum(funding.bigint, COLLATERAL_DECIMALS);

  return Number.isNaN(fundingNum) ? undefined : fundingNum;
};
